import { iDocBaseDataMap } from './docBase.type';

import { docBaseEffects, docBaseReducers } from './docBase.operator';

// DocBase 初始状态
export const docBaseInitDataMap: iDocBaseDataMap = {};

// Model
export const docBaseModel = {
  state: docBaseInitDataMap,
  reducers: docBaseReducers,
  effects: docBaseEffects,
};
